export default "__VITE_ASSET__CgZtVmTE__"